import Modal from './modal';
import type { ModalType } from './types';

type Props = {
  id: string;
  size: Extract<ModalType['size'], 'xs' | 'sm'>;
  color?: Extract<ModalType['color'], 'white'>;
  title?: React.ReactNode;
  content?: React.ReactNode;
  submitButtonText: string;
  closeOnClickOutside: boolean;
  modalSubmit: () => void;
};

export default function AlertModal({
  id,
  size = 'xs',
  color = 'white',
  title,
  content,
  submitButtonText = '확인',
  closeOnClickOutside,
  modalSubmit,
}: Props) {
  return (
    <>
      <Modal.Overlay id={id} closeOnClickOutside={closeOnClickOutside} />
      <Modal size={size} color={color} isHeightAuto>
        <Modal.Body padding="48_32_32">
          {title && <Modal.Title title={title} />}
          {content && <Modal.Message content={content} />}
        </Modal.Body>

        <Modal.Footer buttonsInfo={[{ submitButtonText, modalSubmit }]} />
      </Modal>
    </>
  );
}
